import { addTagInputSelection, setTagInputSelection } from "./tag_input.js";

// Shared filter behavior for ingredient dashboards (costs, allergens, etc.):
// tag filter, type filter, and the surrounding "advanced filters" panel / reset.
// Apply with `Object.assign(HostClass.prototype, IngredientFiltersMixin)`.
// Host must define: `tags` (array), `archived` (bool), `page`,
// `navigate()`, and `showAdvanced()` (page-specific advanced-filters selector).
export const IngredientFiltersMixin = {
  parseTagsFromUrl(parsedUrl) {
    this.tags = parsedUrl.searchParams.getAll("tags[]");
  },

  appendTagsToUrl(url) {
    url.searchParams.delete("tags[]");
    this.tags.forEach((tag) => url.searchParams.append("tags[]", tag));
  },

  parseIngredientTypesFromUrl(parsedUrl) {
    this.ingredientTypes = parsedUrl.searchParams.getAll("ingredient_types[]");
  },

  appendIngredientTypesToUrl(url) {
    url.searchParams.delete("ingredient_types[]");
    // The Vue component already collapses "all checked" to [] before emit, so this just
    // skips the no-op empty case.
    if (this.ingredientTypes.length === 0) {
      return;
    }
    this.ingredientTypes.forEach((t) => url.searchParams.append("ingredient_types[]", t));
  },

  bindIngredientTypeFilter() {
    const filter = this.container.querySelector("ingredient-type-filter");
    if (!filter) return;
    filter.addEventListener("update:model-value", (event) => {
      this.ingredientTypes = event.detail?.[0] || [];
      this.page = 1;
      this.navigate();
    });
  },

  // Pushes `this.ingredientTypes` back into the <ingredient-type-filter> Vue component,
  // for cases where state changed outside the component (popstate, reset).
  syncIngredientTypeFilter() {
    const filter = this.container.querySelector("ingredient-type-filter");
    if (!filter) return;
    filter.dispatchEvent(
      new CustomEvent("external-update:model-value", { detail: [this.ingredientTypes] })
    );
  },

  bindTags() {
    const searchTagInput = document.querySelector("tag-input");
    document.querySelectorAll("ingredient-tag-input").forEach((e) => {
      e.addEventListener("tag-click", (event) => {
        const proposedTag = event.detail[0];
        const hasTag = this.tags.some((tagName) => tagName == proposedTag.name);
        if (!hasTag) {
          addTagInputSelection(searchTagInput, proposedTag);
          this.tags.push(proposedTag.name);
          this.navigate();
        }

        this.showAdvanced();
      });
    });
  },

  bindTagSearchFilter() {
    const searchTagInput = document.querySelector("tag-input");
    searchTagInput.addEventListener("update:model-value", (event) => {
      this.tags = event.detail[0].map((tag) => tag.name);
      this.setSearchFilterTags(this.tags);
      this.page = 1;

      this.navigate();
    });
  },

  setSearchFilterTags(tags) {
    setTagInputSelection(document.querySelector("tag-input"), tags);
  },

  maybeShowAdvanced() {
    if (
      this.archived ||
      (this.ingredientTypes && this.ingredientTypes.length > 0) ||
      this.tags.length > 0
    ) {
      this.showAdvanced();
    }
  },

  hasAnyFilters() {
    return (
      this.q !== "" ||
      this.archived ||
      (this.ingredientTypes && this.ingredientTypes.length > 0) ||
      (this.tags && this.tags.length > 0)
    );
  },

  bindResetFilters() {
    const resetLink = this.container.querySelector("#reset-filters a");
    if (!resetLink) return;
    resetLink.addEventListener("click", (e) => {
      e.preventDefault();
      if (!this.hasAnyFilters()) return;
      this.resetFilters();
    });
  },

  updateResetFiltersUI() {
    const resetContainer = this.container.querySelector("#reset-filters");
    if (!resetContainer) return;

    resetContainer.style.display = this.hasAnyFilters() ? "" : "none";
  },
};
